import { render, staticRenderFns } from "./HeatingElementSettings.vue?vue&type=template&id=540ede71&"
import script from "./HeatingElementSettings.vue?vue&type=script&lang=ts&"
export * from "./HeatingElementSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports